// export const endpoint = 'https://asistenti.323.lv/wp/graphql';
// export const hostName = 'https://asistenti.323.lv';
// export const GA_TRACKING_ID = 'UA-92340767-4';
// export const GA_TRACKING_ID = 'UA-145496413-1'; // Test ID
export const breakPointSizes = {
  phone: 576,
  tablet: 768,
  desktop: 992,
  mobileMenu: 1016,
};
